/**
 * Замена Array.prototype.flatMap: собирает значения из каждого элемента
 * в один плоский массив обычным циклом. flatMap в проекте не используем —
 * см. правило о поддержке старых браузеров в CLAUDE.md.
 */
export const flatMapArray = <T, R>(
  items: readonly T[] | null | undefined,
  getValues: (item: T, index: number) => readonly R[]
): R[] => {
  const result: R[] = [];
  const source = items ?? [];
  for (let i = 0; i < source.length; i++) {
    result.push(...getValues(source[i], i));
  }
  return result;
};

export default flatMapArray;
